<div class="flex flex-col full-grow-no-shrink-no-basis">
  <div class="modal-header flex flex-row justify-between items-center">
    <div class="flex flex-col">
      <h1>Send Password for</h1>
      <h1>{{ data.user.firstName }} {{ data.user.lastName }} ( {{ data.user.email }} )</h1>
    </div>

    <mat-dialog-actions>
      <button class="material-icons" mat-dialog-close
              particleAnalytics
              analyticsCategory="ed-cell-editor-container"
              analyticsAction="close-btn"><i class="fa-regular fa-xmark"></i>
      </button>
    </mat-dialog-actions>

  </div>

  <mat-dialog-content class="full-grow-no-shrink-no-basis">
    <form class="flex flex-col full-grow-no-shrink-no-basis" [formGroup]="sendPasswordForm"
          (keydown.enter)="$event.preventDefault()">
      <div class="flex flex-col flex-1-0-auto ">

        <mat-slide-toggle class="m-b-20" formControlName="generatePassword" [checked]="true"
                          (change)="updatePasswordRequired($event)">
          Automatically generate a password
        </mat-slide-toggle>

        <div class="flex flex-row justify-start items-start auto-flex" *ngIf="isPasswordRequired">
          <mat-form-field appearance="outline" class="flex-1-1-100">
            <mat-label>Password</mat-label>
            <input matInput formControlName="password" type="password"
                   particleAnalytics
                   analyticsCategory="account-settings"
                   analyticsAction="password-input">
            <mat-error *ngIf="sendPasswordFormErrors.password.required">
              Password is required
            </mat-error>
            <mat-error *ngIf="sendPasswordFormErrors.password.minlength">
              Password must have at least 8 characters
            </mat-error>
            <mat-error *ngIf="sendPasswordFormErrors.password.maxlength">
              Password must have at most 16 characters
            </mat-error>
            <mat-error *ngIf="sendPasswordFormErrors.password.pattern">
              Password must have at least 1 lowercase, 1 uppercase, 1 digit and 1 special character
            </mat-error>
          </mat-form-field>
        </div>

        <mat-slide-toggle class="m-b-20" formControlName="passwordChange" [checked]="true">
          Ask for a password change at the next sign-in
        </mat-slide-toggle>

        <mat-slide-toggle formControlName="sendCopyToMe" [checked]="false">
          Send a copy to me
        </mat-slide-toggle>

      </div>
    </form>
  </mat-dialog-content>


  <mat-dialog-actions class="modal-footer flex flex-row justify-between items-center">
    <button mat-button class="mat-flat-button orbitax-footer-button mat-button" [mat-dialog-close]="result">Cancel
    </button>
    <button mat-button (click)="onSave()" [mat-dialog-close]="result" mat-flat-button
            class="orbitax-footer-action-button mat-button mat-flat-button mat-accent" type="button" color="accent"
            [disabled]="sendPasswordForm.invalid" cdkFocusInitial>Send
    </button>
  </mat-dialog-actions>
</div>
